import { useMutation } from '@connectrpc/connect-query'
import { updateBiddingSpotApprovalRequest } from '@ebalance/proto/bffuser/v1/bidding_spot_service-BiddingSpotService_connectquery'
import { useQueryClient } from '@tanstack/react-query'

import { invalidateSpotApprovalRequestQueries } from '~/hooks/bidding/queryKeys'
import { useWorkflowCaseScopedMutation } from '~/hooks/bidding/useWorkflowCaseScopedMutation'
import type { InvalidatingMutationResultFor } from '~/hooks/useInvalidatingMutation'
import { invalidateSpotFeePreviewsOnRejection } from '~/pages/SpotBidding/hooks/spotFeePreviewInvalidation'

/**
 * スポット入札 承認依頼 更新 mutation hook (楽観ロック使用)。 手数料の理由で拒否された時は
 * 開いたままのモーダルが突き合わせているプレビューと設定を取り直す。
 */
export function useUpdateBiddingSpotApprovalRequest(): InvalidatingMutationResultFor<
  typeof updateBiddingSpotApprovalRequest
> {
  const queryClient = useQueryClient()
  return useWorkflowCaseScopedMutation(
    useMutation(updateBiddingSpotApprovalRequest, {
      onSuccess: () => invalidateSpotApprovalRequestQueries(queryClient),
      onError: (err) => invalidateSpotFeePreviewsOnRejection(queryClient, err),
    }),
  )
}
